import React from "react";
import Card from "./Card";
import Banner_English from "../assets/images/Banner_English.jpeg";
import Banner_Hindi from "../assets/images/Banner_Hindi.jpeg";

const cardDataArray = [
  {
    cardBackgroundColor: "rgba(84, 173, 71, 0.1)",
    title: "Search",
    svgColor: "#54AD47",
    linkData: [
      {
        text: "TIN Facilitation Centers cum PAN centers",
        textColor: "black",
        iconColor: "black",
        borderBottom: "1px solid black",
        maxWidth: "207px",
        linkMinWidth: "400px",
        linkMinWidthMobile: "247px",
        href: "/tin-facilities#search-forms"
      },
      {
        text: "PAN Centers",
        textColor: "black",
        iconColor: "black",
        borderBottom: "1px solid black",
        maxWidth: "207px",
        linkMinWidth: "400px",
        linkMinWidthMobile: "247px",
        href: "/pan-center#search-tabs-forms"
      },
      {
        text: "PAN Service Agency Centers",
        textColor: "black",
        iconColor: "black",
        borderBottom: "1px solid black",
        maxWidth: "207px",
        linkMinWidth: "400px",
        linkMinWidthMobile: "247px",
        href: ""
      },
    ],
    defaultLinkMinWidth: window.innerWidth > 1024 ? "420px" : "300px", // Default min width for this card's links
    defaultMaxWidth: "61px", // Default max width for this card's links
  },
  {
    cardBackgroundColor: "#EAF4FA",
    title: "Contact us",
    svgColor: "#3091D0",
    linkData: [
      // As suggested by Rajesh removeing Rights from customer care tab and pages //
      // {
      //   text: "Rights",
      //   textColor: "black",
      //   iconColor: "black",
      //   borderBottom: "1px solid black",
      //   maxWidth: "207px",
      //   linkMinWidth: "400px",
      //   linkMinWidthMobile: "247px",
      //   href: 'https://tinpan.proteantech.in/customer-care.html'
      // },
      {
        text: "Complains/ Queries",
        textColor: "black",
        iconColor: "black",
        borderBottom: "1px solid black",
        maxWidth: "207px",
        linkMinWidth: "400px",
        linkMinWidthMobile: "247px",
        href: "/customerfeedback#customer-care-forms"
      },
      {
        text: "Protean addresses",
        textColor: "black",
        iconColor: "black",
        borderBottom: "1px solid black",
        maxWidth: "207px",
        linkMinWidth: "400px",
        linkMinWidthMobile: "247px",
        href: "/nsdl-addresses#pan-call-center"
      },
    ],
    defaultLinkMinWidth: window.innerWidth > 1024 ? "420px" : "300px", // Default min width for this card's links
  },
];

function TdsBanners() {
  return (
    // <section className="flex flex-col bg-white z-40">
    //   <div className="flex flex-wrap px-[22px] justify-center lg:px-[70px] gap-2 ">
        
    //     <img src={Banner_English}></img>
    //   </div>
    //   <div className="flex flex-wrap px-[22px] justify-center lg:px-[70px] gap-2 ">

    //     <img src={Banner_Hindi}></img>
    //   </div>

      
    // </section>
    <section className="w-full flex py-10 flex-col relative   lg:px-0 ">
      <div className="flex flex-col items-center justify-center gap-10">
        <div className="flex gap-[14px] px-4 lg:px-0 flex-wrap justify-center">
            <div className="max-w-[640px] flex flex-col">
                <img src={Banner_English}></img>
            </div>
            <div className="max-w-[640px] flex flex-col">
                <img src={Banner_Hindi}></img>
            </div>
        </div>
        </div>
        </section>
  );
}

export default TdsBanners;
